import { memo } from 'react';
import cn from 'classnames';
import { IContent, ISection } from 'src/interface';
import { useViewTime } from 'src/hooks';
import ContentSection from 'src/modules/content/components/sections/ContentSection';

interface IProps extends ISection<IContent> {
    contentId: number;
}

export function ContentRelatedSection(props: IProps) {
    const { tracking, contentId } = props;
    const { ref } = useViewTime({
        tracking: tracking,
        contentId: contentId,
        threshold: 0.1,
        onFinish: () => {},
    });

    return (
        <ContentSection
            domRef={ref}
            className="topic-section"
            classTitle={cn(
                'relative',
                'flex ',
                'w-full mb-[12px] pt-[10px]',
                'text-[20px] leading-[16px] font-[900]',
                'uppercase',
                '[&>a]:block',
                '[&_span]:relative [&_span]:inline-block [&_span]:bg-white [&_span]:z-[1] [&_span]:pr-[15px]',
                'before:w-[4px] before:relative before:bg-[#F05B2F]',
                'before:inline-block before:mr-[8px]',
            )}
            {...props}
        />
    );
}

export default memo(ContentRelatedSection);
